import styled from 'styled-components';

export const SocialIconsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3.2rem;
`;

export const SocialIconsItemsWrapper = styled.div`
  display: flex;
  gap: 2.4rem;
`;
